import { AUTH_LOCAL_STORAGE_KEYS } from '@/constants/localStorage';

// File upload utility for Publiish API
interface FileUploadResponse {
  success: string;
  status: number;
  data: Array<{
    cid: string;
    filename: string;
  }>;
}

interface AuthRequest {
  email: string;
  password: string;
}

interface AuthResponse {
  success: string;
  status: number;
  access_token: string;
}

export const authenticateUserPubliishAPI = async (): Promise<string | null> => {
  try {
    const authRequest: AuthRequest = {
      email: 'info@projectwheel.io',
      password: '123456',
    };

    const response = await fetch('https://publiish.io/api/auth/signin', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(authRequest),
    });

    if (!response.ok) {
      throw new Error(`Authentication failed: ${response.status}`);
    }

    const authResponse: AuthResponse = await response.json();

    if (authResponse.success === 'Y' && authResponse.access_token) {
      // Save access token to localStorage
      localStorage.setItem(
        AUTH_LOCAL_STORAGE_KEYS.PUBLISH_ACCESS_TOKEN,
        authResponse.access_token
      );
      return authResponse.access_token;
    } else {
      throw new Error('Authentication response invalid');
    }
  } catch (error) {
    console.error('Authentication error:', error);
    return null;
  }
};

export const uploadFileToPubliish = async (
  file: File,
  authUserId: string = '6',
  brandId: string = '2'
): Promise<string> => {
  try {
    const accessToken =
      (await authenticateUserPubliishAPI()) ||
      localStorage.getItem(AUTH_LOCAL_STORAGE_KEYS.PUBLISH_ACCESS_TOKEN);
    if (!accessToken) {
      throw new Error('No access token found');
    }

    const formData = new FormData();
    formData.append('upload_file', file);

    const response = await fetch(
      `https://publiish.io/api/files/file_add_update?auth_user_id=${authUserId}&brand_id=${brandId}`,
      {
        method: 'POST',
        headers: {
          brand_id: brandId,
          auth_user_id: authUserId,
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      }
    );

    if (!response.ok) {
      throw new Error(
        `File upload failed: ${response.status} ${response.statusText}`
      );
    }

    const result: FileUploadResponse = await response.json();

    if (result.success === 'Y' && result.data && result.data.length > 0) {
      const { cid, filename } = result.data[0];
      const publishedUrl = `https://publiish.io/api/files/publish-link/${cid}?filename=${encodeURIComponent(
        filename
      )}`;
      return publishedUrl;
    } else {
      throw new Error('File upload response invalid');
    }
  } catch (error) {
    console.error('File upload error:', error);
    throw error;
  }
};
